import script from "./diamondsSearchFormPro.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchFormPro.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchFormPro.vue?vue&type=style&index=0&id=06ab2740&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ab2740"]])

export default __exports__